import {
    IProps,
    IRef,
} from '../types';

import React, {
    forwardRef,
    useImperativeHandle,
    useState,
} from 'react';

import {
    CLIENT_FIELD_TYPE,
} from 'entities/payment-methods/constants';

import {
    StringInput,
} from 'components/inputs';

import {
    checkValue,
} from './helpers/check-value';
import {
    formatValue,
} from './helpers/format-value';

const RegexFieldInput = forwardRef<IRef, IProps>((props, ref) => {
    const [value, setValue] = useState('');
    const [isError, setIsError] = useState(false);

    const onChangeValue = (value: string) => {
        setValue(value);
        setIsError(false);
    };

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return {
                    key: props.clientField.key,
                    value: formatValue(value),
                };
            },
            setValue(value) {
                setValue(value?.value ?? '');
            },
            validate() {
                if (props.clientField.validation.type !== CLIENT_FIELD_TYPE.REGEX) {
                    return false;
                }

                const isValid = checkValue(value, props.clientField.validation.regex);

                setIsError(!isValid);

                return isValid;
            },
        };
    });

    return (
        <StringInput
            label={props.clientField.name}
            value={value}
            isDisabled={props.isDisabled}
            isError={isError}
            errorMessage={isError ? props.clientField.validationHint : null}
            onChangeValue={onChangeValue}
        />
    );
});

export default RegexFieldInput;
